import React, {ReactNode, useCallback, useState} from "react"
import clsx from "clsx"
import { Box, Container, makeStyles } from "@material-ui/core"
import HiddenCss from "@material-ui/core/Hidden/HiddenCss"

import { DialogsProvider } from "../Dialogs"
import { Seo } from "../seo"

import { CssBaseLine } from "./CssBaseLine"
import { Header } from "./Header"
import { Footer } from "./Footer"
import { DrawerMenu } from "./DrawerMenu"
import { FloatingMenuButton } from "./FloatingMenuButton"



export interface LayoutProps {
	children: ReactNode
}



export const Layout = (props: LayoutProps) => {
	const { children } = props;
	const classes = useStyles();

	const [ menuOpen, setMenuOpen ] = useState(false);
	const openMenu = useCallback(() => setMenuOpen(true), [setMenuOpen]);
	const closeMenu = useCallback(() => setMenuOpen(false), [setMenuOpen]);

	return (
		<>
			<Seo />
			<CssBaseLine />
			<DialogsProvider>
				<div className={clsx(classes.page, menuOpen && classes.page__menuOpen)}>
					<Header  />
					<Box paddingY={4}>
						<Container maxWidth="lg">
							<>
								{children}
							</>
						</Container>
					</Box>
					<Footer />
				</div>
				<HiddenCss mdUp>
					<FloatingMenuButton onClick={openMenu}/>
					<DrawerMenu
						open={menuOpen}
						onOpen={openMenu}
						onClose={closeMenu}
					/>
				</HiddenCss>
			</DialogsProvider>
		</>
	);
}


const useStyles = makeStyles(theme => ({
	page: {
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.enteringScreen,
			easing: theme.transitions.easing.easeOut,
		}),
	},
	page__menuOpen: {
		transform: 'translateY(-100px)',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.leavingScreen,
			easing: theme.transitions.easing.easeOut,
		}),
	}
}));
